import * as React from 'react';
import Add from '@svg/Add';
import Minus from '@svg/Minus';
import './style.scss';
import { useTranslation } from 'react-i18next';

interface ICounterProps {
    ticketSeq?: string; //票券序號
    lowQty?: number; //至少購買數量
    maxNum?: number; //最多購買數量
    defaultValue: number;
    onChange: (num: number) => void;
    multiple?: number;
    atLeastNum?: number; //目前只for一般商品(該品項最低購買數量)
    disableAdd?: boolean; // 是否disable 增加按鈕
}

const Counter: React.FC<ICounterProps> = (props) => {
    const { t } = useTranslation();
    const { lowQty, maxNum, defaultValue, multiple, atLeastNum, disableAdd } = props;

    // console.log('run Counter');
    // console.log('defaultValue', defaultValue);
    const minLimitRef = React.useRef<HTMLDivElement>(null);
    const maxLimitRef = React.useRef<HTMLDivElement>(null);
    const onIncrement = () => {
        let num: number;
        if (disableAdd) return;
        if (atLeastNum > 1 && atLeastNum > multiple && defaultValue === 0) {
            num = defaultValue + atLeastNum;
        } else {
            if (multiple > 0) {
                //要成倍數增加
                num = (Math.floor(defaultValue / multiple) + 1) * multiple;
            } else {
                num = defaultValue + 1 * multiple;
            }
        }
        if (num > maxNum) {
            return;
        } else {
            props.onChange(num);
        }
    };
    const onDecrement = () => {
        let num: number;
        if (atLeastNum > 1 && defaultValue === atLeastNum) {
            num = 0;
        } else {
            if (defaultValue - 1 * multiple > lowQty) {
                num = defaultValue - 1 * multiple;
            } else {
                num = lowQty;
            }
        }
        if (num < 0 || num < lowQty) {
            return;
        } else {
            props.onChange(num);
        }
    };

    // const isMinusDisabled = defaultValue - 1 * multiple < lowQty;
    // const isAddDisabled = disableAdd || defaultValue + 1 * multiple > maxNum;
    const isMinusDisabled = defaultValue <= lowQty;
    const isAddDisabled =
        disableAdd || (Math.floor(defaultValue / multiple) + 1) * multiple > maxNum;

    return (
        <div className="counter">
            <div className="minLimit">
                <div className="limitText" ref={minLimitRef}>
                    {t('commonComponent.counter.minLimit', {minQty: lowQty})}
                </div>
                <div
                    className={`btn minus ${isMinusDisabled ? 'disabled' : ''}`}
                    onClick={(e) => {
                        // e.preventDefault();
                        // e.stopPropagation();
                        onDecrement();
                    }}
                    onMouseOver={() => {
                        if (defaultValue - 1 * multiple < lowQty && lowQty > 0) {
                            minLimitRef.current.classList.add('show');
                        }
                    }}
                    onMouseLeave={() => {
                        minLimitRef.current.classList.remove('show');
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                >
                    {/* <div className="btnstyle"></div> */}
                    <Minus color={'#f03742'} />
                </div>
            </div>
            <span className="counterNum">{defaultValue}</span>
            <div className="maxLimit">
                <div className="limitText" ref={maxLimitRef}>
                    {t('commonComponent.counter.maxLimit', {maxQty: maxNum})}
                </div>
                <div
                    className={`btn add ${isAddDisabled ? 'disabled' : ''}`}
                    onClick={(e) => {
                        // e.preventDefault();
                        // e.stopPropagation();
                        onIncrement();
                    }}
                    onMouseOver={() => {
                        if (defaultValue + 1 * multiple > maxNum) {
                            maxLimitRef.current.classList.add('show');
                        }
                    }}
                    onMouseLeave={() => {
                        maxLimitRef.current.classList.remove('show');
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                >
                    {/* <div className="btnstyle"></div> */}
                    <Add color={'#f03742'} />
                </div>
            </div>
        </div>
    );
};
Counter.defaultProps = {
    multiple: 1,
    lowQty: 0,
};
export default Counter;
